import React from "react";
import { Sparkles, X } from "lucide-react";
import { Button } from "../ui/button";

const OnboardingBanner = ({ pendingCount, totalCount, onContinue, onDismiss }) => (
  <div className="flex items-center justify-between gap-3 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3">
    <div className="flex items-center gap-2 text-sm text-blue-700">
      <Sparkles className="h-4 w-4 flex-shrink-0" />
      <span>
        Completa la configuración inicial ({totalCount - pendingCount}/{totalCount} pasos)
      </span>
    </div>
    <div className="flex items-center gap-2">
      <Button size="sm" onClick={onContinue}>
        Continuar
      </Button>
      <button
        onClick={onDismiss}
        className="p-1 rounded-lg text-blue-400 hover:bg-blue-100 hover:text-blue-600"
        aria-label="No volver a mostrar"
        title="No volver a mostrar"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  </div>
);

export default OnboardingBanner;
